export default "__VITE_ASSET__kfVx7RVM__"